import React from "react";

function PrivacyPolicy() {
  return (
    <div className="bg-white container">
      <h1>Border City Software Privacy Policy</h1>

      <p>
        <strong>Last Updated</strong> 09 December 2025
      </p>

      <h2>1 Information We Collect</h2>
      <p>We may collect the following information when you use our services</p>
      <ul>
        <li>Personal details such as name email address phone number and contact information</li>
        <li>Account information such as login details and preferences</li>
        <li>Usage information such as pages visited actions taken and device information</li>
        <li>Technical data such as browser type operating system and IP address</li>
      </ul>

      <h2>2 How We Use Your Information</h2>
      <p>We use collected information in order to</p>
      <ul>
        <li>Provide and maintain our services</li>
        <li>Improve performance and user experience</li>
        <li>Respond to support requests and communicate with you</li>
        <li>Protect our systems and prevent misuse</li>
        <li>Meet legal and regulatory requirements</li>
      </ul>

      <h2>3 How We Store and Protect Information</h2>
      <p>
        Border City Software uses secure storage practices and reasonable technical measures to protect your
        information from unauthorised access alteration or misuse. No system is completely secure but we work
        to safeguard your data at all times.
      </p>

      <h2>4 Sharing of Information</h2>
      <p>We do not sell your information. We may share information only in the following situations</p>
      <ul>
        <li>With trusted service providers who support our operations</li>
        <li>When required by law or by a valid government request</li>
        <li>To protect Border City Software rights property and security</li>
      </ul>

      <h2>5 Your Rights</h2>
      <p>You may</p>
      <ul>
        <li>Request access to the information we hold about you</li>
        <li>Request correction or deletion of your information where appropriate</li>
        <li>Withdraw consent where our use of your information is based on consent</li>
        <li>Contact us about any privacy question or concern</li>
      </ul>

      <h2>6 Contact Us</h2>
      <p>
        For privacy related questions or requests contact
        <br />
        <strong>Border City Software</strong>
        <br />
     Info@bordercitysoftware.com
      </p>
    </div>
  );
}

export default PrivacyPolicy;
